import Input from './Input'
import withField, { withValidationFields } from '../withField'

const InputField = withField(Input)
const InputWithValidation = withValidationFields(Input)

export { InputField, InputWithValidation }
export default Input
